// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'phone-ivr';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M9.36 16.92c1.368.864 3.096.648 4.176-.432l.504-.504a1.13 1.13 0 0 0 0-1.584l-2.016-2.016c-.432-.432-1.152-.432-1.584 0s-1.152.432-1.584 0L5.688 9.216c-.432-.432-.432-1.152 0-1.584s.432-1.152 0-1.584L3.672 4.032a1.13 1.13 0 0 0-1.584 0l-.432.504a3.287 3.287 0 0 0-.432 4.176c2.088 3.24 4.896 6.048 8.136 8.208zM9.864.576h1.152c.648 0 1.152.504 1.152 1.152V2.88c0 .648-.504 1.152-1.152 1.152H9.864A1.137 1.137 0 0 1 8.712 2.88V1.656c.072-.576.576-1.08 1.152-1.08zm5.328 0h1.152c.648 0 1.152.504 1.152 1.152V2.88c0 .648-.504 1.152-1.152 1.152h-1.152A1.137 1.137 0 0 1 14.04 2.88V1.656c0-.576.504-1.08 1.152-1.08zM9.864 5.904h1.152c.648 0 1.152.504 1.152 1.152v1.152c0 .648-.504 1.152-1.152 1.152H9.864a1.137 1.137 0 0 1-1.152-1.152V6.984c.072-.576.576-1.08 1.152-1.08zm5.328 0h1.152c.648 0 1.152.504 1.152 1.152v1.152c0 .648-.504 1.152-1.152 1.152h-1.152a1.137 1.137 0 0 1-1.152-1.152V6.984c0-.576.504-1.08 1.152-1.08z'
  />
);

export const viewBox = '0 0 18 18';
